import React, {Component} from 'react';
import './NotificationCard.css';
import Card from "../../components/card/Card";
import mainAPI from "../../api/MainAPI";
import Label from "../../components/label/Label";
import PrimaryButton from "../../components/primaryButton/PrimaryButton";
import CreateNotificationPopup, {
  NotificationExplanationMessage
} from "../../popups/createNotificationPopup/CreateNotificationPopup";
import Row from "../../components/row/Row";

export default class NotificationCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notifications_by_day: [],
      notifications_by_hour: []
    }
  }

  componentDidMount = async () => {
    await this.getData();
  }

  getData = async () => {
    const [notifications_by_day, notifications_by_hour] = await Promise.all([
      mainAPI.notification_by_day.all(),
      mainAPI.notification_by_hour.all()
    ]);
    if (this.props.unitId) {
      this.setState({
        notifications_by_hour: notifications_by_hour.filter(filterByUnit(this.props.unitId)),
        notifications_by_day: notifications_by_day.filter(filterByUnit(this.props.unitId))
      });

    } else {
      this.setState({
        notifications_by_hour: notifications_by_hour,
        notifications_by_day: notifications_by_day
      });
    }

  }

  showNewNotificationPopup = (day_or_hour) => {
    window.popupController.show(CreateNotificationPopup, {
      unitId: this.props.unitId,
      onClose: this.getData,
      day_or_hour
    });
  };

  render() {
    return (
      <Card className="g-notification-card">
        <Label bold large black className={'small-margin'}>
          Notifications
        </Label>

        <Row>
          <Label bold black className={'small-margin'}>Notifications by Hour</Label>
          <PrimaryButton className={'create-notification'}
                         onClick={x => this.showNewNotificationPopup('notification_by_hour')}>New
            Notification</PrimaryButton>
        </Row>
        <Card className={'small-margin'}>
          {this.state.notifications_by_hour.map((notif) => {
            return <NotificationRow unitId={this.props.unitId} getData={this.getData}
                                    notification={notif}></NotificationRow>
          })}
        </Card>
				<Row>
					<Label bold black className={'small-margin'}>Notifications by Day</Label>
					<PrimaryButton className={'create-notification'}
												 onClick={x => this.showNewNotificationPopup('notification_by_day')}>New
						Notification</PrimaryButton>
				</Row>
				<Card className={'small-margin'}>
					{this.state.notifications_by_day.map((notif) => {
						return <NotificationRow unitId={this.props.unitId} getData={this.getData}
																		notification={notif}></NotificationRow>
					})}
				</Card>
				{this.props.after}
      </Card>
    )
  }
}

const NotificationRow = ({notification, getData, unitId}) => {
  const day_or_hour = ('end_hour' in notification) ? 'notification_by_hour' : 'notification_by_day'
	let unitName = '';
	if(notification.unit__name){
		unitName = ` (${notification.unit__name})`
	}
  return <div className={'notification-row'} onClick={() => {
    window.popupController.show(CreateNotificationPopup, {
      unitId,
      id: notification.id,
      day_or_hour,
      onClose: getData
    });
  }}>
    <Label black bold medium-plus className={'top'}>{notification.name + unitName}</Label>
    <NotificationExplanationMessage className={'bottom'} {...notification} day_or_hour={day_or_hour}/>
  </div>
};

const filterByUnit = (unit_id) => {
  return (notif) => {
    return notif.unit_id == unit_id;
  }
}


// WEBPACK FOOTER //
// ./src/cards/notificationCard/NotificationCard.jsx